import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '',
    redirect: '/'
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  },
  {
    path: '/AboutUs',
    name: 'AboutUs',
    component: () => import('@/views/AboutUsView.vue')
  },
  {
    path: '/LeaderBoard',
    name: 'LeaderBoard',
    component: () => import('@/views/LeaderBoardView.vue')
  },
  {
    path: '/longbench2',
    name: 'Longbench2',
    component: () => import('@/views/Longbench2View.vue')
  },
  {
    path: '/Models',
    name: 'Models',
    component: () => import('@/views/ModelsView.vue')
  },
  {
    path: '/modelsDetails',
    component: () => import('@/views/ModelsDetailView.vue')
  },
  {
    path: '/Profile',
    name: 'Profile',
    component: () => import('@/views/ProfileView.vue')
  },
  {
    path: '/Submit',
    name: 'Submit',
    component: () => import('@/views/SubmitView.vue')
  },
  {
    path: '/Tasks',
    name: 'Tasks',
    component: () => import('@/views/TasksView.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/Page404.vue')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
